// UI twin of the existing server workspace contract; parity is pinned by tests.
// UI cannot import the server. Validate restored state as well as typed input.
import { z } from "zod";
export const workspaceSettingsInput = z
  .object({
    defaultAgentModel: z.string().optional(),
    maxAgents: z.number().optional(),
    allowMemberAgentCreation: z.boolean().optional(),
    agentPermissionMode: z.enum(["ask", "auto"]).optional(),
    agentWorkspaceContext: z.string().optional(),
    publicChannelCreatePolicy: z.enum(["everyone", "admins", "owner"]).optional(),
    privateChannelCreatePolicy: z.enum(["everyone", "admins", "owner"]).optional(),
    browserApprovals: z.boolean().optional(),
  })
  .passthrough();

export function validateWorkspaceInput(input: Record<string, unknown>, creating: boolean): void {
  if (
    (creating || input.name !== undefined) &&
    (typeof input.name !== "string" || !input.name.trim())
  )
    throw new Error("name required");
  if (!workspaceSettingsInput.optional().safeParse(input.settings).success)
    throw new Error("invalid workspace settings");
}
